import type { SchemaField } from '@cli-types/core-engine/schema.js'

export function normalizeEntitySlugField(field: SchemaField, sourceField?: string): SchemaField {
  return {
    ...field,
    required: true,
    ...(sourceField && !field.hidden ? { defaultValueFrom: sourceField } : {})
  }
}
